var map = {
	"./birthday.jpg": 6947,
	"./buzz.jpg": 2814,
	"./emailfoot.png": 9811,
	"./emailhead.jpg": 2776,
	"./longservice.jpg": 5665,
	"./recognise.jpg": 8837,
	"./solar.jpg": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;